import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaLock, FaGlobe, FaFileContract, FaArrowLeft } from 'react-icons/fa';
import { useSite } from '../context/SiteContext';
import { getMediaUrl } from '../services/api';
import './OfficialLogin.css';

const OfficialLogin = () => {
  const { config, moduleAccess } = useSite();
  const showTradeLicense = moduleAccess.trade_license;

  useEffect(() => {
    if (!showTradeLicense) {
      window.location.href = '/admin/';
    }
  }, [showTradeLicense]);

  if (!showTradeLicense) {
    return null;
  }

  return (
    <div className="official-login-page">
      <Link to="/" className="official-login-back">
        <FaArrowLeft /> Back to Website
      </Link>

      <div className="official-login-wrapper">
        <div className="official-login-header">
          {config?.logo && (
            <img
              src={getMediaUrl(config.logo)}
              alt={config.site_name}
              className="official-login-logo"
            />
          )}
          <h1>{config?.site_name || 'Municipal Corporation'}</h1>
          <p>Official staff login — select your portal</p>
        </div>

        <div className="official-login-options two-options">
          <a href="/admin/" className="official-login-card cms-card">
            <div className="card-icon">
              <FaGlobe />
            </div>
            <h2>CMS / Website Login</h2>
            <p>
              Manage website content, pages, news, notices, departments, and site settings.
            </p>
            <span className="card-action">
              <FaLock /> Sign in to CMS
            </span>
          </a>

          <Link to="/office" className="official-login-card trade-card">
            <div className="card-icon">
              <FaFileContract />
            </div>
            <h2>Trade License Portal</h2>
            <p>
              Process applications, verify documents, collect payments, and issue licenses.
            </p>
            <span className="card-action">
              <FaLock /> Sign in to Trade License Portal
            </span>
          </Link>
        </div>

        <p className="official-login-footer">
          For citizens applying for trade licenses, visit{' '}
          <Link to="/trade-license">Trade License Services</Link>.
        </p>
      </div>
    </div>
  );
};

export default OfficialLogin;
